import { UtilService } from './util.service';
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from "@angular/core";
import { Router } from '@angular/router';
import { UserData } from '../models/userData';
import { NoProfile } from '../models/no_profile';
import { Message } from '../models/messsage';
import { ProfileResponse } from '../models/profile_response';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface ProfileByIdResponse {
    results?: unknown[];
    [key: string]: unknown;
}

interface ProfileApiResponse {
    youtube?: string;
    terms_of_work?: string | null;
    [key: string]: unknown;
}

@Injectable({
    providedIn: "root"
})
export class ProfileService {
    private util = inject(UtilService);
    private http = inject(HttpClient);
    private router = inject(Router);


    private userData: UserData;

    newProfile(data: Record<string, unknown>) {
        const url = environment.api.baseUrl + environment.api.endpoints.register;
        return this.http.post<UserData>(url, data).subscribe({
            next: (data) => {
                this.userData = data;
                this.router.navigate(['/new-account-confirmation']);
            },
            error: () => console.log('error')
        });
    }

    searchMainProfile(text: string) {
        const url = environment.api.baseUrl + environment.api.endpoints.search_main + text;
        return this.http.get(url);
    }

    getProfileById(id): Observable<ProfileByIdResponse> {
        const url = environment.api.baseUrl + environment.api.endpoints.profiles + `?id=${id}`;
        return this.http.get<ProfileByIdResponse>(url);
    }

    getProfile() {
        if (localStorage.getItem("currentHasProfile") != null) {
            //console.log('current user', JSON.parse(localStorage.getItem('currentProfile')))
            return JSON.parse(localStorage.getItem('currentProfile'));
        }

        return false;
    }

    getProfileApi(id: string): Observable<ProfileApiResponse> {
        const url = environment.api.baseUrl + environment.api.endpoints.profile + '?id=' + id
        return this.http.get<ProfileApiResponse>(url)
    }

    searchProfileId(id: number): Observable<unknown> {
        const url = environment.api.baseUrl + environment.api.endpoints.search_profiles + '?user=' + id
        return this.http.get(url).pipe(
            map(data => {
                return data
            }),
            catchError(error => {
                console.log(error)
                return throwError(() => error)
            })
        )
    }

    getProfileAudioSample() {
        const url = environment.api.baseUrl;
        const profile = this.getProfile();

        if (profile['audio_sample'] != '' && profile['audio_sample'] != null) {
            return url + profile['audio_sample'].substring(1);
        }

        return false;
    }

    getProfilePicture() {
        const profile = this.getProfile();
        const url = environment.api.baseUrl;

        if (profile
            && 'profile_picture' in profile
            && profile.profile_picture != null) {
            return url + profile.profile_picture.substring(1);
        }

        return "./assets/imgs/perfil/elizabeth-almeida.jpg";
    }

    getAudioSample() {
        const profile = this.getProfile();
        const url = environment.api.baseUrl;
        if (profile
            && 'audio_sample' in profile
            && profile.audio_sample != null) {
            return url + profile.audio_sample.substring(1);
        }
        return "";
    }

    setProfile() {
        const url = environment.api.baseUrl + environment.api.endpoints.hasProfile;
        return this.http.get<ProfileResponse | NoProfile>(url).subscribe({
            next: (response) => {
                if (response.message_code == 200) {
                    localStorage.setItem('currentHasProfile', 'true');
                    localStorage.setItem('currentProfile', JSON.stringify(response.data));
                } else {
                    localStorage.setItem('currentHasProfile', 'false');
                    localStorage.setItem('currentProfile', 'false');
                }
            },
            error: error => console.log(error)
        });
    }

    getGenres() {
        const url = environment.api.baseUrl + environment.api.endpoints.genres;
        return this.http.get(url);
    }

    getMeasures() {
        const url = environment.api.baseUrl + environment.api.endpoints.measure;
        return this.http.get(url);
    }

    getPaymentMethods() {
        const url = environment.api.baseUrl + environment.api.endpoints.payment_methods;
        return this.http.get(url);
    }

    getCategory(parent_id) {
        const url = environment.api.baseUrl + environment.api.endpoints.speciality_by_parent + parent_id;
        return this.http.get(url);
    }

    getCategoryByProfile(id) {
        const url = environment.api.baseUrl + environment.api.endpoints.category_by_profile + id;
        return this.http.get(url);
    }

    updateProfile(form, _audio_file = null, step = 1) {

        let url = environment.api.baseUrl + environment.api.endpoints.profile;
        const profileData = this.getProfile();
        const profile = Object.assign({}, profileData, form);

        // somente especilidade.
        if (step == 1) {
            profile.deadline = form.deadline;
            profile.payment_method = form.payment_method;
            profile.number_revision = form.number_revision;
            profile.profile_categories = [];
            profile.profile_categories_remove = form.profile_category_remove;
        }

        url = `${url}${profile.id}/`;

        const formData = new FormData();

        //if (audio_file != null) {
        //formData.append('audio_sample', audio_file.blob, audio_file.name);
        //}

        if (form.genres != undefined && form.genres.length > 0) {
            form.genres.forEach(function (objCategory) {
                const objProfileCategory = {
                    'category': objCategory.genre,
                    'is_main': false
                };

                if ('id' in objCategory) {
                    objProfileCategory['id'] = objCategory.id;
                }

                profile.profile_categories.push(objProfileCategory);
            });
        }

        if (form.musicians != undefined && form.musicians.length > 0) {
            form.musicians.forEach(function (objCategory) {
                const objProfileCategory = {
                    'category': objCategory.speciality_id,
                    'measure': objCategory.measure,
                    'price': objCategory.price,
                    'is_main': (objCategory.main == null) ? false : objCategory.main
                };

                if ('id' in objCategory) {
                    objProfileCategory['id'] = objCategory.id;
                }

                profile.profile_categories.push(objProfileCategory);
            });
        }

        if (form.shows != undefined && form.shows.length > 0) {
            form.shows.forEach(function (objCategory) {
                const objProfileCategory = {
                    'category': objCategory.speciality_id,
                    'measure': objCategory.measure,
                    'price': objCategory.price,
                    'is_main': (objCategory.main == null) ? false : objCategory.main
                };

                if ('id' in objCategory) {
                    objProfileCategory['id'] = objCategory.id;
                }

                profile.profile_categories.push(objProfileCategory);
            });
        }

        if (form.producers != undefined && form.producers.length > 0) {
            form.producers.forEach(function (objCategory) {
                const objProfileCategory = {
                    'category': objCategory.speciality_id,
                    'measure': objCategory.measure,
                    'price': objCategory.price,
                    'is_main': (objCategory.main == null) ? false : objCategory.main
                };

                if ('id' in objCategory) {
                    objProfileCategory['id'] = objCategory.id;
                }

                profile.profile_categories.push(objProfileCategory);
            });
        }


        if (form.broadcasters != undefined && form.broadcasters.length > 0) {
            form.broadcasters.forEach(function (objCategory) {
                const objProfileCategory = {
                    'category': objCategory.speciality_id,
                    'measure': objCategory.measure,
                    'price': objCategory.price,
                    'is_main': (objCategory.main == null) ? false : objCategory.main
                };

                if ('id' in objCategory) {
                    objProfileCategory['id'] = objCategory.id;
                }

                profile.profile_categories.push(objProfileCategory);
            });
        }

        formData.append('profile', JSON.stringify(profile));

        return new Promise<void>((resolve, reject) => {
            this.http.put<Message>(url, formData).subscribe({
                next: (data) => {
                    if (data.message_code && data.message_code >= 400) {
                        reject({ message: data.message || 'Erro ao salvar.' });
                    } else {
                        this.setProfile();
                        resolve();
                    }
                },
                error: (err) => {
                    const msg = err?.error?.message || err?.message || 'Erro ao salvar.';
                    reject({ message: msg });
                }
            });
        });
    }

    saveSpeciality(data) {
        const params: SaveSpecialityParams = {};

        params.profile = {};
        params.profile.deadline = data.deadline;
        params.profile.payment_method = data.payment_method;
        params.profile.number_revision = data.number_revision;
        params.profile_categories = [];
        params.profile_categories_remove = data.profile_category_remove;
        params.payment_method = 1;

        const profileSession = this.getProfile();

        if (profileSession) {
            params.profile.id = profileSession.id;
        }

        data.genres.forEach(function (objCategory) {
            const objProfileCategory = {
                'category': objCategory.genre,
                'is_main': false
            };

            if ('id' in objCategory) {
                objProfileCategory['id'] = objCategory.id;
            }

            params.profile_categories.push(objProfileCategory);
        });

        data.musicians.forEach(function (objCategory) {
            const objProfileCategory = {
                'category': objCategory.speciality_id,
                'measure': objCategory.measure,
                'price': objCategory.price,
                'is_main': (objCategory.main == null) ? false : objCategory.main
            };

            if ('id' in objCategory) {
                objProfileCategory['id'] = objCategory.id;
            }

            params.profile_categories.push(objProfileCategory);
        });

        (data.shows ?? []).forEach(function (objCategory) {
            const objProfileCategory = {
                'category': objCategory.speciality_id,
                'measure': objCategory.measure,
                'price': objCategory.price,
                'is_main': (objCategory.main == null) ? false : objCategory.main
            };

            if ('id' in objCategory) {
                objProfileCategory['id'] = objCategory.id;
            }

            params.profile_categories.push(objProfileCategory);
        });

        data.producers.forEach(function (objCategory) {
            const objProfileCategory = {
                'category': objCategory.speciality_id,
                'measure': objCategory.measure,
                'price': objCategory.price,
                'is_main': (objCategory.main == null) ? false : objCategory.main
            };

            if ('id' in objCategory) {
                objProfileCategory['id'] = objCategory.id;
            }

            params.profile_categories.push(objProfileCategory);
        });

        data.broadcasters.forEach(function (objCategory) {
            const objProfileCategory = {
                'category': objCategory.speciality_id,
                'measure': objCategory.measure,
                'price': objCategory.price,
                'is_main': (objCategory.main == null) ? false : objCategory.main
            };

            if ('id' in objCategory) {
                objProfileCategory['id'] = objCategory.id;
            }

            params.profile_categories.push(objProfileCategory);
        });

        const url = environment.api.baseUrl + environment.api.endpoints.profile;
        return this.http.post<Message>(url, params).subscribe({
            next: (data) => {
                if (data.message_code == 200) {
                    this.setProfile();
                    this.router.navigate(['/profile/specialty-confirmation']);
                }
            },
            error: error => console.log(error)
        });
    }

    uploadProfilePhoto(file: File) {
        const formData = new FormData();
        const profile = this.getProfile();

        if (file) {
            formData.append('profile_picture', file, file.name);
        }

        formData.append('profile', JSON.stringify(profile));

        let url = environment.api.baseUrl + environment.api.endpoints.profile;

        url = `${url}${profile.id}/`;

        return this.http.put<Message>(url, formData).subscribe({
            next: (data) => {
                if (data.message_code == 200) {
                    this.setProfile();
                    this.router.navigate(['/main/menu']);
                }
            },
            error: () => console.log('error')
        });
    }

    uploadUserPhoto(id, file: File) {
        const formData = new FormData();
        if (file) {
            formData.append('user_picture', file, file.name);
        }
        let url = environment.api.baseUrl + environment.api.endpoints.update_user_photo;
        url = `${url}${id}/`;

        return this.http.put<Message>(url, formData);
        // .subscribe({
        //     next: (data: any) => {
        //         if(data.message_code == 200) {
        //             const loggedUser = {...this.authService.getLoggedUser()};
        //             loggedUser.user_picture = data.user_picture;
        //             localStorage.setItem('currentAVUser', JSON.stringify(loggedUser));
        //             this.router.navigate(['/main/menu']);                     
        //         }
        //     },
        //     error: error => this.util.errorToast(error)
        // });
    }

    // uploadUserFiles(audios: any[], pictures: any[]) 
    // {
    //     const profile = this.getProfile();
    //     const formData = new FormData();

    //     console.log(audios)
    //     console.log(pictures)
    //     console.log(profile.id)

    //     if (pictures) {
    //         if( pictures[0] ) { formData.append('profile_picture_1', pictures[0], 'picture1.jpg') };
    //         if( pictures[1] ) { formData.append('profile_picture_2', pictures[1], 'picture2.jpg') };
    //         if( pictures[2] ) { formData.append('profile_picture_3', pictures[2], 'picture3.jpg') };
    //     }

    //     if (audios) {
    //         if( audios[0] && audios[0].blob ) { formData.append('audio_sample_1', audios[0].blob, 'audio1.mp3') };
    //         if( audios[1] && audios[1].blob ) { formData.append('audio_sample_2', audios[1].blob, 'audio2.mp3') };
    //         if( audios[2] && audios[2].blob ) { formData.append('audio_sample_3', audios[2].blob, 'audio3.mp3') };
    //     }

    //     let url  = environment.api.baseUrl + environment.api.endpoints.profile_files;
    //     url = `${url}${profile.id}/`;

    //     return this.http.put<Message>(url, formData);        
    // }

    update(form, audios, images) {
        let url = environment.api.baseUrl + environment.api.endpoints.profile_update;
        const profileData = this.getProfile();
        const profile = Object.assign({}, profileData, form.value);

        url = `${url}${profile.id}/`;

        const formData = new FormData();
        formData.append("work", form.get("work").value ? form.get("work").value : "");
        formData.append("equipment", form.get("equipment").value ? form.get("equipment").value : "");
        formData.append("inspiration", form.get("inspiration").value ? form.get("inspiration").value : "");
        formData.append("youtube", form.get("youtube").value ? form.get("youtube").value : "");
        formData.append("website", form.get("website").value ? form.get("website").value : "");

        if (audios) {
            if (audios[0] && audios[0]?.blob) {
                formData.append('audio_sample_1', audios[0].blob, audios[0].file.name)
            } else {
                if (!audios[0]) {
                    formData.append('audio_sample_1', "")
                }
            }

            if (audios[1] && audios[1]?.blob) {
                formData.append('audio_sample_2', audios[1].blob, audios[1].file.name)
            } else {
                if (!audios[1]) {
                    formData.append('audio_sample_2', "")
                }
            }

            if (audios[2] && audios[2]?.blob) {
                formData.append('audio_sample_3', audios[2].blob, audios[2].file.name)
            } else {
                if (!audios[2]) {
                    formData.append('audio_sample_3', "")
                }
            }
        }

        if (images) {
            if (images[0] && images[0]?.blob) {
                formData.append('profile_picture_1', images[0].blob, 'picture1.jpg')
            } else {
                if (!images[0]) {
                    formData.append('profile_picture_1', "")
                }
            }

            if (images[1] && images[1]?.blob) {
                formData.append('profile_picture_2', images[1].blob, 'picture2.jpg')
            } else {
                if (!images[1]) {
                    formData.append('profile_picture_2', "")
                }
            }

            if (images[2] && images[2]?.blob) {
                formData.append('profile_picture_3', images[2].blob, 'picture3.jpg')
            } else {
                if (!images[2]) {
                    formData.append('profile_picture_3', "")
                }
            }
        }


        return this.http.put<Message>(url, formData).subscribe({
            next: (data) => {
                if (!Number.isNaN(data.message_code)) {
                    this.setProfile();
                    this.router.navigate(['/profile/specialty-confirmation']);
                }
            },
            error: error => console.log(error)
        });
    }

    // ---------------------------------------------------------------------
    // Contratante (shows)
    // ---------------------------------------------------------------------

    private contratanteParentId: number = null;

    /** Resolve (e cacheia) o id da categoria-pai CONTRATANTE_SHOWS (category_type=1). */
    async getContratanteParentId(): Promise<number> {
        if (this.contratanteParentId) {
            return this.contratanteParentId;
        }
        const url = environment.api.baseUrl + environment.api.endpoints.categories + '?category_type=1';
        const res = await this.http.get(url).toPromise() as CategoryListResponse;
        const list: CategoryLike[] = (res?.results ?? res ?? []) as CategoryLike[];
        const found = list.find((c) => c.code === 'CONTRATANTE_SHOWS');
        this.contratanteParentId = found ? Number(found.id) : null;
        return this.contratanteParentId;
    }

    /** Opções de segmentos do contratante (filhos de CONTRATANTE_SHOWS). */
    async getContratanteSegments(): Promise<CategoryLike[]> {
        const parentId = await this.getContratanteParentId();
        if (!parentId) {
            return [];
        }
        const res = await this.getCategory(parentId).toPromise() as CategoryListResponse;
        return res?.results ?? [];
    }

    /**
     * Decide a visibilidade dos grupos do menu a partir das categorias do perfil.
     * Regra (paridade com o web): usuário sem categorias é neutro e vê ambos os grupos.
     */
    async getContratanteFlags(): Promise<{ hasContratanteShows: boolean; hasOtherCategory: boolean }> {
        const profile = this.getProfile();
        if (!profile || !profile.id) {
            return { hasContratanteShows: false, hasOtherCategory: false };
        }
        try {
            const parentId = await this.getContratanteParentId();
            const cats = await this.getCategoryByProfile(profile.id).toPromise() as CategoryListResponse;
            const list: CategoryLike[] = Array.isArray(cats) ? cats : (cats?.results ?? []);

            let hasContratanteShows = false;
            let hasOtherCategory = false;
            for (const cat of list) {
                const isContratante =
                    parentId != null && Number(cat.category_parent) === Number(parentId);
                if (isContratante) {
                    hasContratanteShows = true;
                } else {
                    hasOtherCategory = true;
                }
            }
            return { hasContratanteShows, hasOtherCategory };
        } catch (err) {
            console.warn('Falha ao carregar flags de contratante', err);
            return { hasContratanteShows: false, hasOtherCategory: false };
        }
    }

    /**
     * Destaques do contratante (história/youtube/site).
     * Paridade web: PUT api/profile/me/update/{id}/ (multipart) — UserService.updateHighlight.
     */
    updateContratanteHighlight(
        profileId: number,
        data: { biography?: string; youtube?: string; website?: string; logo?: File }
    ): Observable<Message> {
        const formData = new FormData();
        formData.append('biography', data.biography || '');
        formData.append('youtube', data.youtube || '');
        formData.append('website', data.website || '');
        if (data.logo) {
            formData.append('logo', data.logo, data.logo.name || 'logo.jpg');
        }

        let url = environment.api.baseUrl + environment.api.endpoints.profile_update;
        url = `${url}${profileId}/`;
        return this.http.put<Message>(url, formData);
    }

    /**
     * Persiste os profile_categories do perfil.
     * Paridade web: PUT api/profile/{id}/ com { profile: { ..., profile_categories, profile_categories_remove } }.
     * IMPORTANTE: profile_categories deve conter o conjunto COMPLETO a manter (segmentos do
     * contratante + categorias preservadas de especialista/gênero), senão o backend remove as ausentes.
     */
    updateContratanteCategories(
        profileId: number,
        profile_categories: unknown[],
        profile_categories_remove: unknown[],
        base: ContratanteBase
    ): Observable<Message> {
        const profile: Record<string, unknown> = {
            accept_fees: base?.accept_fees ?? false,
            accept_offers: base?.accept_offers ?? false,
            deadline: base?.deadline ?? 0,
            number_revision: base?.number_revision ?? 0,
            terms_of_work: base?.terms_of_work ?? '',
            payment_method: 1,
            profile_categories,
            profile_categories_remove,
        };

        let url = environment.api.baseUrl + environment.api.endpoints.profile;
        url = `${url}${profileId}/`;
        return this.http.put<Message>(url, { profile });
    }

    /** Recarrega o perfil em sessão (currentProfile/currentHasProfile) de forma aguardável. */
    async refreshProfile(): Promise<void> {
        const url = environment.api.baseUrl + environment.api.endpoints.hasProfile;
        try {
            const response = await this.http.get<ProfileResponse | NoProfile>(url).toPromise();
            if (response && response.message_code == 200) {
                localStorage.setItem('currentHasProfile', 'true');
                localStorage.setItem('currentProfile', JSON.stringify(response.data));
            } else {
                localStorage.setItem('currentHasProfile', 'false');
                localStorage.setItem('currentProfile', 'false');
            }
        } catch (err) {
            console.log(err);
        }
    }

    updateExperience(form) {
        let url = environment.api.baseUrl + environment.api.endpoints.profile_update;
        const profileData = this.getProfile();
        const profile = Object.assign({}, profileData, form.value);

        url = `${url}${profile.id}/`;

        const formData = new FormData();
        formData.append("comfort_zone", form.get("comfort_zone").value ? form.get("comfort_zone").value : "");
        formData.append("biography", form.get("biography").value ? form.get("biography").value : "");
        formData.append("who_you_worked_with", form.get("who_you_worked_with").value ? form.get("who_you_worked_with").value : "");


        return this.http.put<Message>(url, formData).subscribe({
            next: (data) => {
                if (!Number.isNaN(data.message_code)) {
                    this.setProfile();
                    this.router.navigate(['/profile/specialty-confirmation']);
                }
            },
            error: error => console.log(error)
        });
    }
}

interface SaveSpecialityParams {
    profile?: Record<string, unknown>;
    profile_categories?: Record<string, unknown>[];
    profile_categories_remove?: unknown;
    payment_method?: number;
    [key: string]: unknown;
}

interface CategoryLike {
    id: number | string;
    code?: string;
    category_parent?: unknown;
    [key: string]: unknown;
}

interface CategoryListResponse {
    results?: CategoryLike[];
    [key: string]: unknown;
}

interface ContratanteBase {
    accept_fees?: boolean;
    accept_offers?: boolean;
    deadline?: number;
    number_revision?: number;
    terms_of_work?: string;
    [key: string]: unknown;
}